
import { axiosInstance } from "@/lib/axiosInstance";
import config from "@/lib/config";
import axios from "axios";

export async function fetchEmployees(): Promise<any> {
  try {
    const response = await axiosInstance.get(`${config.apiUrl}/auth/employee`);
    return response.data.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(
        error.response?.data.message || "Error fetching Employees"
      );
    } else {
      throw new Error("An unknown error occurred");
    }
  }
}
